import { type BaseModalProps, createModalSystem } from '@cartwhl/common/modals';

import type { WorkflowKey } from 'components/WorkflowModal/index';

// Define modal payloads
export type EnterpriseContactReason =
  | 'pilot_cartwheel'
  | 'request_demo'
  | 'pricing_plans'
  | 'partnership_inquiry'
  | 'education'
  | 'product_technical_support'
  | 'other';

export type ModalPayloads = {
  EXPLAIN_SPINS: undefined;
  PURCHASE_SPINS: undefined;
  ENTERPRISE_CONTACT: { reason?: EnterpriseContactReason } | undefined;
  WORKFLOW: { key: WorkflowKey };
  NOTIFY_ME: { excitedAbout?: string; interestLabel?: string } | undefined;
};

export type ModalName = keyof ModalPayloads;
export type ModalProps<T extends ModalName> = BaseModalProps<ModalPayloads[T]>;

// Create and export the modal system
export const { useModal, ModalManager } = createModalSystem<ModalPayloads>({
  EXPLAIN_SPINS: () => import('@cartwhl/ui/modals/SpinsExplainedModal'),
  PURCHASE_SPINS: () => import('@cartwhl/ui/modals/PurchaseSpinsModal'),
  ENTERPRISE_CONTACT: () => import('components/EnterpriseContactModal'),
  WORKFLOW: () => import('components/WorkflowModal/index'),
  NOTIFY_ME: () => import('components/NotifyMeModal'),
});
